<template>
  <div class="report">
    <div class="page__header">
      <div class="page__title">{{ $t(`pageTitles.${"report"}`) }}</div>
      <div class="page__right"></div>
    </div>

    <div class="report__container">
      <div class="report__left">
        <div class="box box--default report__user-info">
          <div class="label label--gradient">{{ $t(`userReport.${"userInfo"}`) }}</div>
          <Loading v-if="chooseDetailsLoading" />
          <template v-else>
            <template v-if="selectedAgentData">
              <div class="report__user-info-icon icon icon__edit" @click="editUser()"></div>
              <div class="report__user-info-avatar">
                <img v-if="selectedAgentData.photo" :src="selectedAgentData.photo" alt="" />
                <div v-else class="initials" :style="{ background: selectedAgentData.color || '#7f8fa4' }">
                  {{
                    parseInitials(
                      selectedAgentData.name.split(" ")[0],
                      selectedAgentData.name.split(" ")[1]
                    )
                  }}
                </div>
              </div>
              <div class="report__user-info-roles">
                <div class="report__user-info-role" v-for="(role, index) in selectedAgentData.roles" :key="role.id">
                  {{ role.title }}
                  <span v-if="index !== selectedAgentData.roles.length - 1">,</span>
                </div>
              </div>
              <div class="report__user-info-name" style="padding: 0 15px;">
                {{ selectedAgentData.name }}

              </div>
              <div class="report__user-info-company">
                {{ selectedAgentData.company_name }}
              </div>
            </template>

            <template v-else>
              <div class="report__user-info-icon icon icon__edit disabled"></div>
              <div class="report__user-info-avatar">
                <img src="../assets/icons/default/no-user.svg" />
              </div>
              <div class="report__user-info-roles">
                <div class="report__user-info-role">{{ $t('userReport.userRole') }}</div>
              </div>
              <div class="report__user-info-name">{{ $t('userReport.userName') }}</div>
              <div class="report__user-info-company">{{ $t('userReport.company') }}</div>
            </template>
          </template>

        </div>

        <div class="box box--default report__choose-details">
          <div class="label label--gradient">{{ $t(`userReport.${"chooseDetails"}`) }}</div>
          <Loading v-if="chooseDetailsLoading" />
          <div class="report__choose-details-body" v-else>
            <div class="form__field">
              <VSelect class="select select--default" :placeholder="$t('addPrivateCostumerModal.teams')"
                :class="{ 'select--error': teamIdHasError }" :options="fetchedTeams" :reduce="(team) => team.id"
                :getOptionLabel="(team) => `${team.name}`
                  " @update:modelValue="fetchUserData($event);" v-model="teamId" />
              <div class="form__error" v-if="teamIdHasError">
                {{ $t('addPrivateCostumerModal.teamErrorMsg') }}
              </div>
            </div>


            <template v-if="selectedAgentData">
              <div class="form__field">
                <VSelect class="select select--default" :class="{ 'select--error': userIdHasError }" :options="agents"
                  :reduce="(agent) => agent.id" :placeholder="$t('addPrivateCostumerModal.agents')" :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`
                    " v-model="userId" />
                <div class="form__error" v-if="userIdHasError">
                  {{ $t('addOfferModal.agentErrorMsg') }}
                </div>
              </div>

              <div class="form__field">
                <VSelect class="select select--default" :class="{ 'select--error': paidStatusHasError }"
                  :options="statuses" :reduce="(status) => status.value"
                  :placeholder="$t('addPrivateCostumerModal.status')" label="title" v-model="paidStatus" />
                <div class="form__error" v-if="paidStatusHasError">
                  {{ $t('addPrivateCostumerModal.subStatusErrorMsg') }}
                </div>
              </div>

              <div class="report__choose-details-row">
                <VSelect class="select select--default report__choose-details-month" :options="months"
                  :reduce="(month) => month.value" :placeholder="$t('userReport.month')" label="title"
                  v-model="month" />
                <VSelect class="select select--default report__choose-details-year" :options="years"
                  :placeholder="$t('userReport.year')" v-model="year" />
              </div>

              <div class="report__choose-details-title">{{ $t(`userReport.${"period"}`) }}</div>

              <div class="form__field">
                <div class="report__choose-details-datepickers" :class="{
                  'report__choose-details-datepickers--error': periodHasError,
                }">
                  <Datepicker class="input input--default datepicker-input"
                    :placeholder="$t('addOfferModal.dateOfStart')" :config="statics.datePickerConfig"
                    v-model="startDate" />
                  <div class="input input--default report__choose-details-seperator">
                    -
                  </div>
                  <Datepicker class="input input--default datepicker-input" :placeholder="$t('addPolicyModal.endDate')"
                    :config="statics.datePickerConfig" v-model="endDate" />
                </div>
                <div class="form__error">{{ periodErrorPlaceholder }}</div>
              </div>

              <div class="report__choose-details-buttons">
                <button type="button" class="button button--default" :disabled="reportsLoading"
                  @click="searchReports(teamId)">
                  {{ $t(`userReport.${"searchBtn"}`) }}
                </button>
                <button type="button" class="button button--default button--reset" @click="reset()">
                  {{ $t(`userReport.${"resetBtn"}`) }}
                </button>
              </div>
            </template>
            <template v-else>
              <div class="form__field disabled-el">
                <VSelect class="select select--default" disabled :placeholder="$t('addPrivateCostumerModal.agents')" />
              </div>

              <div class="form__field disabled-el">
                <VSelect class="select select--default" disabled :placeholder="$t('addPrivateCostumerModal.status')" />
              </div>

              <div class="report__choose-details-row disabled-el">
                <VSelect class="select select--default report__choose-details-month" disabled
                  :placeholder="$t('userReport.month')" />
                <VSelect class="select select--default report__choose-details-year" disabled
                  :placeholder="$t('userReport.year')" />
              </div>

              <div class="report__choose-details-title">{{ $t(`userReport.${"period"}`) }}</div>

              <div class="form__field">
                <div class="report__choose-details-datepickers disabled-el">
                  <Datepicker style="color: var(--text-8) !important;" class="input input--default  vs__search"
                    :placeholder="$t('addOfferModal.dateOfStart')" disabled v-model="startDate" />
                  <div style="color: var(--text-8) !important;"
                    class="input input--default report__choose-details-seperator">
                    -
                  </div>
                  <Datepicker class="input input--default  vs__search" style="color: var(--text-8) !important;"
                    :placeholder="$t('addPolicyModal.endDate')" disabled v-model="endDate" />
                </div>
              </div>

              <div class="report__choose-details-buttons disabled-el ">
                <button type="button" class="button button--default  " disabled>
                  {{ $t(`userReport.${"searchBtn"}`) }}
                </button>
              </div>
            </template>

          </div>
        </div>
      </div>
      <div class="report__right">
        <div class="box box--default report__details">
          <div class="label label--gradient">{{ $t(`userReport.${"reportsDetails"}`) }}</div>
          <Loading v-if="reportsLoading" />

          <template v-else>
            <div class="report__details-header table__header box box--default" v-if="reports.length">
              <div class="table__label table__label--medium">{{ $t(`userReport.${"date"}`) }}</div>
              <div class="table__label table__label--large">{{ $t(`userReport.${"customer"}`) }}</div>
              <div class="table__label table__label--large">{{ $t(`userReport.${"company"}`) }}</div>
              <div class="table__label table__label--medium">{{ $t(`userReport.${"insType"}`) }}</div>
              <div class="table__label table__label--medium">{{ $t(`userReport.${"policyNr"}`) }}</div>
              <div class="table__label table__label--medium">{{ $t(`userReport.${"agent"}`) }}</div>
              <div class="table__label table__label--medium">{{ $t(`userReport.${"type"}`) }}</div>
              <div class="table__label table__label--medium">{{ $t(`userReport.${"balance"}`) }}</div>
              <div class="table__label table__label--medium table__label--last"></div>
            </div>
            <div class="report__details-body table__body">
              <button v-if="!reports.length && route.query.paidStatus === 'true'" type="button"
                class="report__details-add button button--default button--animated"
                @click="store.commit('setShowAddTransactionModal', true)">
                <div class="button__icon"></div>
              </button>

              <template v-if="!reports.length">
                <NoData type="default" />
              </template>

              <template v-else>
                <div class="report__details-reports row" v-for="(report, index) in reports"
                  :key="reports[index].period">
                  <div class="report__details-year">
                    {{
                      `${getMonthName(reports[index].period.split("-")[1])} ${reports[index].period.split("-")[0]
                      }`
                    }}
                  </div>
                  <div class="report__details-reports-body">
                    <Report :teamId="teamId" v-for="r in reportTypes[index].policyReports" :key="r.id" :report="r" />

                    <div class="report__details-manual" v-if="reportTypes[index].manualReports.length">
                      <div class="report__details-manual-seperator"></div>
                      <div class="report__details-manual-header">
                        <div class="report__details-manual-data report__details-manual-data--small">
                          {{ $t(`userReport.${"date"}`) }}
                        </div>
                        <div class="report__details-manual-data report__details-manual-data--medium">
                          {{ $t(`userReport.${"agent"}`) }}
                        </div>
                        <div class="report__details-manual-data report__details-manual-data--medium">
                          {{ $t(`userReport.${"type"}`) }}
                        </div>
                        <div class="report__details-manual-data report__details-manual-data--large">
                          {{ $t(`userReport.${"description"}`) }}
                        </div>
                        <div class="report__details-manual-data report__details-manual-data--medium">
                          {{ $t(`userReport.${"balance"}`) }}
                        </div>
                        <div class="table__label table__label--medium table__label--last">

                        </div>
                      </div>
                      <Report :teamId="teamId" v-for="r in reportTypes[index].manualReports" :key="r.key" :report="r" />
                    </div>
                    <div class="report__details-info">
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"commission"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.commissions }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"cancellationFee"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.storno }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"brokerageFee"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.brokerFees }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"other"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.others }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"payroll"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.lohnzahlung }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"cancellationAccDeduction"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.deposit }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"cancellationAccPayout"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.depositReturn }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"bonus"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.bonus }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"grossCommission"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ parseFloat((report.meta.commission_total + report.meta.deposit +
                              report.meta.storno).toFixed(2)) }}
                          </div>
                        </div>
                      </div>

                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"cancellationReserves"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ parseFloat((report.meta.deposit_reserves_total + report.meta.deposit).toFixed(2)) }}
                          </div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"socialSecurityContributions"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.AHV }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"bvgContribution"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.BVG }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">{{ $t(`userReport.${"cancellationFee"}`) }}</div>
                          <div class="report__details-info-data">{{ parseFloat(((-1) * report.meta.deposit).toFixed(2))
                          }}
                          </div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label report__details-info-label--bold">
                            {{ $t(`userReport.${"netCommission"}`) }}
                          </div>
                          <div class="report__details-info-data report__details-info-data--bold">
                            {{ report.meta.subtotal }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row report__details-info-row--seperator">
                        <div class="report__details-seperator"></div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label report__details-info-label--bold">
                            {{ $t(`userReport.${"cancellationReservesTotal"}`) }}
                          </div>
                          <div class="report__details-info-data report__details-info-data--bold">
                            {{ report.meta.deposit_reserves_total }}
                          </div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label">
                            {{ $t(`userReport.${"finishedPayout"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.finished_payout }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label report__details-info-label">
                            {{ $t(`userReport.${"childAllowances"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.familyAllowance }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label report__details-info-label">
                            {{ $t(`userReport.${"expenses"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.expenses }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label report__details-info-label">
                            {{ $t(`userReport.${"specialExpenses"}`) }}
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.specialExpenses }}
                          </div>
                        </div>
                      </div>
                      <div class="report__details-info-row">
                        <div class="report__details-info-column">
                          <div class="report__details-info-label"></div>
                          <div class="report__details-info-data"></div>
                        </div>
                        <div class="report__details-info-column">
                          <div class="report__details-info-label report__details-info-label--bold">
                            <button v-if="canMakePayment(index)" type="button"
                              class="button button--default button--pay" @click="
                                openPayoutReviewModal(
                                  report.meta,
                                  reports[index].period
                                )
                                ">
                              {{ $t(`userReport.${"payout"}`) }}
                            </button>
                            <template v-else>{{ $t(`userReport.${"payout"}`) }}</template>
                          </div>
                          <div class="report__details-info-data">
                            {{ report.meta.payout }}
                          </div>
                        </div>
                      </div>
                      <button v-if="route.query.paidStatus === 'true'" type="button"
                        class="report__details-add button button--default button--animated"
                        @click="store.commit('setShowAddTransactionModal', true)">
                        <div class="button__icon"></div>
                      </button>
                      <div class="report__details-info-print">
                        <div class="icon icon icon__print" v-if="paidStatus == true"
                          @click="openReport(reports[index].period)"></div>
                      </div>
                      <div class="icon icon__excel" v-if="paidStatus == true"
                        @click="openReportExcel(reports[index].period)"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import Report from "@/components/Reports/Report";
import NoData from "@/partials/NoData";
import moment from "moment";
import { parseInitials } from "@/helpers/entityParsers";
import api from "@/api";
import { useI18n } from 'vue-i18n';

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();

const store = useStore();
const route = useRoute();
const router = useRouter();
const instance = getCurrentInstance();


// Reactive data
const statuses = ref([]);
const months = ref([]);

const startYear = ref(2015);
const endYear = ref(new Date().getFullYear());
const chooseDetailsLoading = ref(false);
const reportsLoading = ref(false);
const showBvg = ref(false);

const userId = ref("");
const paidStatus = ref("");
const month = ref("");
const year = ref("");
const startDate = ref("");
const endDate = ref("");
const ahv = ref(true);
const bvg = ref("");

const userIdHasError = ref(false);
const paidStatusHasError = ref(false);
const periodHasError = ref(false);
const periodErrorPlaceholder = ref("");

const agents = ref([]);
const selectedAgentData = ref(null);

const teamIdHasError = ref(null);
const teamId = ref(null);

const years = ref(null);

// Computed properties
const reportForms = computed(() => store.getters.reportForms);
const reports = computed(() => store.getters.reports);
const loggedUser = computed(() => store.getters.loggedUser);

const fetchedTeams = computed(() => {
  if (loggedUser.value.teams.length > 0) {
    return loggedUser.value.teams;
  } else {
    return null;
  }
});

const parsedReports = computed(() => {
  return reports.value.map((report) => {
    let reportsList = [];
    for (let r in report) {
      if (r !== "meta" && r !== "period") {
        reportsList = [...reportsList, report[r]];
      }
    }
    return reportsList;
  });
});

const reportTypes = computed(() => {
  return parsedReports.value.map((report) => {
    let types = {
      manualReports: [],
      policyReports: [],
    };
    report.forEach((r) => {
      if (r.policy_service) {
        types.policyReports = [...types.policyReports, r];
      } else {
        types.manualReports = [...types.manualReports, r];
      }
    });
    return types;
  });
});

// Methods
const clearQueryParameters = () => {
  if (Object.keys(route.query).length > 0) {
    router.replace({ query: {} }).catch(err => {
      if (err.name !== "NavigationDuplicated") {
        console.error(err);
      }
    });
  }
};

const canMakePayment = (index) => {
  const { manualReports, policyReports } = reportTypes.value[index];
  return [...manualReports, ...policyReports].every(
    (report) => report.type
  );
};

const getMonthName = (monthNum) => {
  return months.value.find((m) => m.value === Number(monthNum)).title;
};

const setDefaultFilterValues = () => {
  userId.value = agents.value[0].id;
  paidStatus.value = statuses.value[0].value;
  month.value = moment().month() + 1;
  year.value = moment().year();

  if (
    userId.value != route.query.userId ||
    paidStatus.value != (route.query.paidStatus === "true") ||
    month.value != route.query.month ||
    year.value != route.query.year
  ) {
    router.replace({
      query: {
        ...route.query,
        userId: userId.value,
        paidStatus: statuses.value[0].value,
        month: moment().month() + 1,
        year: moment().year(),
      },
    });
  }
};

const validateUserId = () => {
  if (!userId.value) {
    userIdHasError.value = true;
  } else {
    userIdHasError.value = false;
  }
};

const validatePaidStatus = () => {
  if (paidStatus.value !== true && paidStatus.value !== false) {
    paidStatusHasError.value = true;
  } else {
    paidStatusHasError.value = false;
  }
};

const validatePeriod = () => {
  if (startDate.value && endDate.value) {
    if (
      moment(startDate.value, "YYYY-MM-DD").isAfter(
        moment(endDate.value, "YYYY-MM-DD")
      )
    ) {
      periodHasError.value = true;
      periodErrorPlaceholder.value =
        t("messages.endYearGreaterThanStartYear");
      return;
    } else {
      periodHasError.value = false;
      periodErrorPlaceholder.value = "";
    }
  } else if (startDate.value) {
    if (!endDate.value) {
      periodHasError.value = true;
      periodErrorPlaceholder.value = t("messages.selectEndDate");
    }
  } else if (endDate.value) {
    if (!startDate.value) {
      periodHasError.value = true;
      periodErrorPlaceholder.value = t("messages.selectStartDate");
    }
  } else {
    periodHasError.value = false;
    periodErrorPlaceholder.value = "";
  }
};

const openPayoutReviewModal = (metaData, period) => {
  store.commit("setPayoutReviewModalData", {
    ...metaData,
    period,
  });
  store.commit("setShowPayoutReviewModal", true);
};

const editUser = () => {
  store.commit("setUserToEdit", userId.value);
  store.commit("setIsEdit", true);
  store.commit("setShowAddUserModal", true);
};

const fetchUserData = async (id) => {
  clearQueryParameters();

  selectedAgentData.value = null;
  agents.value = null;
  store.commit("setReportForms", null);

  await store.dispatch("getReportForms", id);

  agents.value = reportForms.value.agents;
  if (
    Number(route.query.userId) &&
    (route.query.paidStatus === "true" ||
      route.query.paidStatus === "false") &&
    ((route.query.startDate && route.query.endDate) ||
      route.query.month ||
      route.query.year)
  ) {
    userId.value = Number(route.query.userId);
    paidStatus.value = route.query.paidStatus === "true";
    month.value = route.query.month
      ? Number(route.query.month)
      : null;
    year.value = route.query.year;
    startDate.value = route.query.startDate;
    endDate.value = route.query.endDate;
    ahv.value = route.query.ahv === "true";
    showBvg.value = route.query.bvg === "true";
    bvg.value = route.query.bvgValue;
    if (
      !userIdHasError.value &&
      !paidStatusHasError.value &&
      !periodHasError.value
    ) {
      await store.dispatch("getReports", {
        team_id: id,
        query: { ...route.query },
      });
    }
  } else {
    setDefaultFilterValues();
  }

  setAgentData();
  setYears();
};

const setAgentData = () => {
  const agent = agents.value.find((agent) => agent.id === userId.value);
  if (agent) {
    selectedAgentData.value = {
      company_name: agent.company_name,
      photo: agent.photo ? agent.photo.preview : null,
      name: `${agent.first_name} ${agent.last_name}`,
      roles: agent.roles,
      color: agent.color || null,
    };
  } else {
    selectedAgentData.value = null;
  }
};

const setYears = () => {
  if (endYear.value >= startYear.value) {
    years.value = Array.from(
      { length: endYear.value - startYear.value + 1 },
      (_, index) => startYear.value + index
    ).reverse();
  } else {
    years.value = [];
    store.commit("setToast", {
      display: true,
      type: "error",
      message: t("messages.endYearGreaterThanStartYear")
    });
  }
};

const searchReports = async (teamIdParam) => {
  clearQueryParameters();

  try {
    validateUserId();
    validatePaidStatus();
    validatePeriod();
    if (
      !userIdHasError.value &&
      !paidStatusHasError.value &&
      !periodHasError.value
    ) {
      const currentQuery = {
        userId: route.query.userId,
        paidStatus: route.query.paidStatus === "true",
        month: route.query.month,
        year: route.query.year,
        startDate: route.query.startDate,
        endDate: route.query.endDate,
        ahv: route.query.ahv === "true",
        showBvg: route.query.bvg === "true",
        bvgValue: route.query.bvgValue,
      };

      const newQuery = {
        userId: userId.value,
        paidStatus: paidStatus.value,
        month: month.value,
        year: year.value,
        startDate: startDate.value,
        endDate: endDate.value,
        teamId: teamId.value
      };

      if (JSON.stringify(currentQuery) !== JSON.stringify(newQuery)) {
        reportsLoading.value = true;
        await router.replace({ query: newQuery });
        await store.dispatch("getReports", {
          team_id: teamIdParam,
          query: { ...route.query },
        });
        reportsLoading.value = false;
      }
    }
  } catch (err) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: err.response?.data?.message || t("messages.failedToFetchReports")
    });
  }
};

const openReport = async (period) => {
  try {
    const response = await api({ requiresAuth: true }).post(
      `/v1/payment-report-pdf`,
      {
        user_id: userId.value,
        paid_status: true,
        year: Number(period.split("-")[0]),
        month: Number(period.split("-")[1]),
        team_id: teamId.value
      },
      {
        responseType: "blob"
      }
    );

    if (!response.data || response.data.size === 0) {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: t("messages.emptyPdfResponse")
      });
      return;
    }

    const contentType = response.headers['content-type'] || 'application/pdf';

    const blob = new Blob([response.data], { type: contentType });
    const fileURL = window.URL.createObjectURL(blob);

    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", "agent_payout.pdf");
    document.body.appendChild(fileLink);

    if (contentType.includes("application/pdf") ||
      contentType.includes("image/jpeg") ||
      contentType.includes("image/png")) {
      const { width, height } = screen;
      window.open(
        fileURL,
        "_blank",
        `location=yes,width=${width},height=${height},scrollbars=yes,status=yes`
      );
    } else {
      fileLink.click();
    }

    document.body.removeChild(fileLink);
    window.URL.revokeObjectURL(fileURL);
  } catch (err) {
    if (err.response) {
      const errorMessage = err.response.data instanceof Blob
        ? t("messages.failedToDownloadPDF")
        : (err.response.data.message || t("messages.failedToDownloadPDF"));

      store.commit("setToast", {
        display: true,
        type: "error",
        message: errorMessage
      });
    } else {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: t("messages.failedToDownloadPDF")
      });
    }
  }
};
const openReportExcel = async (period) => {
  try {
    const response = await api({ requiresAuth: true }).post(
      "/v1/payment-report-excel",
      {
        user_id: userId.value,
        paid_status: true,
        year: Number(period.split("-")[0]),
        month: Number(period.split("-")[1]),
        team_id: teamId.value,
      },
      {
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type:
        response.headers["content-type"] ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const fileURL = window.URL.createObjectURL(blob);

    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", "agent_payout.xlsx");

    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);

    window.URL.revokeObjectURL(fileURL);
  } catch (err) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: t("messages.failedToDownloadExcel"),
    });
  }
};
const reset = () => {
  clearQueryParameters();
  setDefaultFilterValues();
  ahv.value = true;
  showBvg.value = false;
  bvg.value = "";
};

// Watchers
watch(userId, () => {
  validateUserId();
});

watch(paidStatus, () => {
  validatePaidStatus();
});

watch(startDate, () => {
  validatePeriod();
});

watch(endDate, () => {
  validatePeriod();
});

// Lifecycle
onMounted(async () => {
  // Initialize translated values
  const $t = instance.proxy.$t;

  statuses.value = [
    { title: $t('statuses.booked'), value: true },
    { title: $t('statuses.open'), value: false }
  ];

  months.value = [
    { title: $t('months.all'), value: null },
    { title: $t('months.1'), value: 1 },
    { title: $t('months.2'), value: 2 },
    { title: $t('months.3'), value: 3 },
    { title: $t('months.4'), value: 4 },
    { title: $t('months.5'), value: 5 },
    { title: $t('months.6'), value: 6 },
    { title: $t('months.7'), value: 7 },
    { title: $t('months.8'), value: 8 },
    { title: $t('months.9'), value: 9 },
    { title: $t('months.10'), value: 10 },
    { title: $t('months.11'), value: 11 },
    { title: $t('months.12'), value: 12 },
  ];

  if (!instance.proxy.$checkRolePermission('report_access')) {
    router.push('/dashboard');
  } else {
    clearQueryParameters();

    chooseDetailsLoading.value = true;
    reportsLoading.value = true;

    chooseDetailsLoading.value = false;
    reportsLoading.value = false;
  }
});

onUnmounted(() => {
  store.commit("setReports", []);
  clearQueryParameters();
});

// Expose to template
defineExpose({
  statics,
  moment,
  parseInitials,
});
</script>

<style scoped lang="scss">
[data-theme="dark"] .disabled-el {
  opacity: 0.7;
}

.datepicker-input::placeholder {
  color: var(--text-2) !important;
}


.report,
.report__left,
.report__right,
.report__details {
  height: 100%;
}

.report {
  &__container {
    display: flex;
    padding-top: 20px;
    height: calc(100% - 24px - 20px);
  }

  .label {
    padding: 12px 15px;
    z-index: 3;
  }

  &__left {
    width: 250px;
    margin-right: 20px;
  }

  &__right {
    width: calc(100% - 250px - 20px);
  }

  &__user-info {
    height: 220px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 2px solid var(--border-2);
      overflow: hidden;
    }

    &-role {
      margin: 5px 0;
      color: var(--text-5);
      font-size: var(--x-smaller);
      display: inline-block;

      span {
        margin: 0 5px 0 -2px;
      }
    }

    &-name {
      color: var(--text-9);
      font-size: var(--medium);
      font-family: var(--muli-text-light);
      margin: 10px 0;
    }

    &-company {
      color: var(--text-9);
      font-size: 14px;
      font-family: var(--muli-text-light)
    }

    &-icon {
      position: absolute;
      top: 30px;
      right: 30px;
    }
  }

  &__choose-details {
    height: calc(100% - 220px - 40px);
    padding: 45px 15px 0 15px;

    &-body {
      height: 100%;
      overflow: auto;
    }

    &-row,
    &-datepickers,
    &-seperator {
      display: flex;
    }

    &-datepickers {
      background: var(--bg-3);
      border-radius: var(--radius-1);
      border: 1px solid transparent;

      &--error {
        background-color: var(--highlight-2);
        border-color: var(--border-9);
      }
    }

    &-month {
      flex: 1;
      margin-right: 15px;
    }

    &-year {
      width: 80px;
    }

    .select {
      margin-bottom: 20px;
    }

    &-checkboxes,
    &-checkbox {
      display: flex;
      justify-content: space-between;
    }

    &-checkboxes {
      flex-wrap: wrap;
      border-top: 1px solid var(--border-7);
      padding-top: 20px;
      margin-top: 20px;
    }

    &-checkbox {
      margin: 0 20px 20px 0;
      width: calc(50% - 20px);
      align-items: center;
    }

    &-label {
      color: var(--text-2);
    }

    &-seperator {
      width: 20px;
      border-radius: 0;
      align-items: center;
      justify-content: center;
    }

    &-input {
      width: 55px;
      height: 28px;
      background: var(--bg-16);
      border-radius: var(--radius-1);
      text-align: center;
      color: var(--text-2);
    }

    &-title {
      color: var(--text-5);
      margin-bottom: 10px;
    }

    &-title,
    &-label {
      font-family: var(--muli-text-semi-bold);
      font-size: var(--x-small);
    }

    &-buttons {
      padding: 0 45px;

      .button {
        width: 100%;

        &--reset {
          border: 1px solid var(--border-2);
          background: 0;
          color: var(--text-2);
          margin-top: 15px;
          box-shadow: none;

          &:hover {
            background-color: var(--bg-2);
            color: var(--text-1);
          }
        }
      }
    }
  }

  &__details {
    padding: 30px 0 10px 0;

    &-header {
      margin-bottom: 0;

      .table__label--last {
        max-width: 45px;
      }
    }

    &-body {
      height: calc(100% - 36px);
      overflow: auto;
    }

    &-add {
      position: absolute;
      top: 68px;
      left: 45px;
      width: 55px;
      height: 38px;
      transform: translateX(-50%);

      &:hover {
        width: 65px;
      }
    }

    &-year {
      color: var(--text-2);
      font-size: var(--medium);
      font-family: var(--muli-text-bold);
      margin: 15px 0 15px 10px;
    }

    &-info,
    &-info-row,
    &-info-column {
      display: flex;
    }

    &-info {
      padding: 30px 75px 10px 15px;
      margin-top: -30px;
      border-radius: var(--radius-1);
      flex-direction: column;
      align-items: flex-end;
      position: relative;

      &-label,
      &-data {
        color: var(--text-9);

        &--bold {
          font-family: var(--muli-text-bold);
        }
      }

      &-label {
        width: 70%;
      }

      &-data {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 30%;
        max-width: 100%;
      }

      &-row {
        width: 70%;

        &--seperator {
          width: calc(70% + 45px);
        }
      }

      &-column {
        width: calc(50% - 100px);
        justify-content: space-between;
        align-items: center;
        padding: 5px;
        text-align: right;

        &:first-child {
          margin-right: 200px;
        }
      }

      &-print {
        right: 10px;
        bottom: 10px;
      }

      .button,
      &-print {
        position: absolute;
      }

      .button {
        top: 50%;
        left: 60px;
        margin: initial;
        transform: translate(-50%, -50%);

        &--pay {
          position: static;
          transform: initial;
          width: 116px;
          height: 30px;
        }
      }
    }

    &-seperator {
      height: 1px;
      width: 100%;
      background: var(--bg-18);
      margin: 5px 0;
    }

    &-reports {
      &-body {
        background: var(--bg-16);
        border-radius: var(--radius-1);
      }
    }

    :deep(.report) {
      display: flex;

      .table__label--last {
        max-width: 45px;
      }
    }

    &-manual-header {
      display: flex;

      .table__label--last {
        max-width: 45px;
      }
    }

    :deep(.report__data),
    :deep(.report-data),
    &-manual__data,
    &-manual-data {
      border-right: 1px solid var(--border-12);
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 15px 10px;
      color: var(--text-9);
    }

    :deep(.report__data--small),
    :deep(.report__data--last),
    :deep(.report-data--small),
    :deep(.report-data--last),
    &-manual__data--small,
    &-manual__data--last,
    &-manual-data--small,
    &-manual-data--last {
      flex: 1;
    }

    :deep(.report__data--medium),
    :deep(.report-data--medium),
    &-manual__data--medium,
    &-manual-data--medium {
      flex: 2;
    }

    :deep(.report__data--large),
    :deep(.report-data--large),
    &-manual__data--large,
    &-manual-data--large {
      flex: 3;
    }

    :deep(.report__data--last),
    :deep(.report-data--last),
    &-manual__data--last,
    &-manual-data--last {
      max-width: 45px;
      height: initial;
    }

    :deep(.report__data:last-child),
    :deep(.report-data:last-child),
    &-manual__data:last-child,
    &-manual-data:last-child {
      border-right: 0;
    }

    &-manual {
      &-seperator {
        width: calc(100% - 20px);
        margin: auto;
        height: 1px;
        background: var(--border-12);
      }

      &-header {
        padding: 5px 0;

        .report__details-manual-data {
          text-align: center;
          color: var(--text-2);
          font-size: var(--x-small);
          padding: 5px 10px;
        }
      }
    }
  }

  &__user-info,
  &__choose-details,
  &__details {
    position: relative;
    background: var(--bg-1);
  }
}
</style>
